import React, { lazy } from "react";
import Loadable from "../components/Loadable";
import { routeCheck } from "app/data/roles";

const Credit = Loadable(
  lazy(() => import("app/views/finance/credit/CreditList"))
);
const TransferCredit = Loadable(
  lazy(() => import("app/views/finance/transferCredit/TransferCreditList"))
);
const Invoice = Loadable(
  lazy(() => import("app/views/finance/invoice/InvoiceList"))
);
const Statement = Loadable(
  lazy(() => import("app/views/finance/statement/Statement"))
);

const UploadFAI = Loadable(
  lazy(() => import("app/views/finance/uploadFaiFile/UploadFAI"))
);

const financePaths = routeCheck(
  [
    { path: "/finance/credit/list", element: <Credit /> },
    { path: "/finance/transferCredit/list", element: <TransferCredit /> },
    { path: "/finance/invoice/list", element: <Invoice /> },
    { path: "/finance/statement", element: <Statement /> },
    { path: "/finance/uploadFaiFile", element: <UploadFAI /> },
  ],
  false
);

export default financePaths;
